import React from 'react'
import style from './edgeblock.module.scss';

export default (props) => {
	let text = props.children;
	return (
		<blockquote className={style.edgeBlock}>{ text }</blockquote>
	)
}